<template>
  <teleport to="body">
    <div v-if="modelValue" class="info-overlay" @keydown.esc="close">
      <div class="info-modal" role="dialog" :aria-label="title">
        <header class="info-header">
          <h3>{{ title }}</h3>
          <button class="info-close" @click="close">✕</button>
        </header>
        <section class="info-body">
          <slot />
        </section>
        <footer class="info-footer">
          <button v-if="showCancelButton" class="info-exit info-cancel" @click="cancelAndClose">{{ cancelText }}</button>
          <button v-if="showConfirmButton" class="info-exit info-confirm" @click="confirmAndClose">{{ confirmText }}</button>
        </footer>
      </div>
    </div>
  </teleport>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'InfoPopup',
  props: {
    modelValue: { type: Boolean, required: true },
    title: { type: String, default: 'Info' },
    showConfirmButton: { type: Boolean, default: true },
    showCancelButton: { type: Boolean, default: true },
    confirmText: { type: String, default: 'Confirm' },
    cancelText: { type: String, default: 'Cancel' },
  },
  emits: ['update:modelValue', 'confirm', 'cancel'],
  setup(props, { emit }) {
    function close() {
      emit('update:modelValue', false);
    }
    function confirmAndClose() {
      emit('confirm');
      emit('update:modelValue', false);
    }
    function cancelAndClose() {
      emit('cancel');
      emit('update:modelValue', false);
    }
    return { close, confirmAndClose, cancelAndClose };
  }
});
</script>

<style scoped>
.info-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10000;
}

.info-modal {
  background: #fff;
  width: 500px;
  max-width: calc(100vw - 32px);
  max-height: calc(100vh - 32px);
  border-radius: 8px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.2);
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.info-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem;
}

.info-close {
  background: none;
  border: none;
  font-size: 1.2rem;
  cursor: pointer;
}

.info-body {
  padding: 1rem;
  flex: 1;
  min-height: 0;
  overflow-y: auto;
}

.info-footer {
  padding: 0.75rem 1rem;
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  flex-wrap: wrap;
}

.info-exit {
  margin-left: 0;
  padding: 6px 14px;
  background: var(--background-white-hover);
  border: 1px solid transparent;
  border-radius: 4px;
  cursor: pointer;
  transition: background .2s;
}

.info-exit:hover {
  background: var(--background-white-hover-darker);
}

button {
  font-family: var(--app-font)
}

.info-confirm {
  background-color: var(--purple);
  color: white;
  font-weight: 500;
}

.info-confirm:hover {
  background-color: var(--purple-hover);
  color: white;
}
</style>
